import React, { useEffect, useState } from 'react'
import AdminSidebar from '../../components/admin-sidebar/AdminSidebar'
import { Outlet } from 'react-router-dom'
import { useAppNavigate } from '../../context/AppContext'
import { getStorageKey } from '../../utils/appType'
import './AdminLayout.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'

type Props = {}
const c = 'admin-layout'

const AdminLayout = (props: Props) => {
  const navigate = useAppNavigate()
  const [sidebarOpen, setSidebarOpen] = useState(false)

  useEffect(() => {
    const token = localStorage.getItem(getStorageKey('token'))

    if (!token) {
      navigate('/login', { replace: true })
    }
  }, [navigate])

  if (!localStorage.getItem(getStorageKey('token'))) {
    return null
  }

  return (
    <div className={c}>
      <button
        className={`${c}__hamburger`}
        onClick={() => setSidebarOpen(true)}
        aria-label='Open menu'
      >
        <FontAwesomeIcon icon={faBars} />
      </button>

      {sidebarOpen && (
        <div
          className={`${c}__overlay`}
          onClick={() => setSidebarOpen(false)}
        />
      )}

      <div className={`${c}__sidebar ${sidebarOpen ? 'open' : ''}`}>
        <AdminSidebar onClose={() => setSidebarOpen(false)} />
      </div>

      <div className={`${c}__content`}>
        <Outlet />
      </div>
    </div>
  )
}

export default AdminLayout
